export const EMPTY_EDITOR_STATE = JSON.stringify({
    root: {
        children: [
            {
                type: "paragraph",
                children: [],
                direction: null,
                format: "",
                indent: 0,
                version: 1,
            },
        ],
        direction: null,
        format: "",
        indent: 0,
        type: "root",
        version: 1,
    },
});

export function createPlainTextEditorState(value = '') {
    const normalizedValue = typeof value === 'string' ? value.replace(/\r\n/g, '\n') : '';
    const lines = normalizedValue.split('\n');

    if (lines.length === 1 && lines[0] === '') {
        return EMPTY_EDITOR_STATE;
    }

    return JSON.stringify({
        root: {
            children: lines.map((line) => ({
                type: 'paragraph',
                children: line
                    ? [
                        {
                            detail: 0,
                            format: 0,
                            mode: 'normal',
                            style: '',
                            text: line,
                            type: 'text',
                            version: 1,
                        },
                    ]
                    : [],
                direction: null,
                format: '',
                indent: 0,
                version: 1,
            })),
            direction: null,
            format: '',
            indent: 0,
            type: 'root',
            version: 1,
        },
    });
}
